import { render, staticRenderFns } from "./SeparatorExtended.vue?vue&type=template&id=1f856512&scoped=true"
import script from "./SeparatorExtended.vue?vue&type=script&lang=js"
export * from "./SeparatorExtended.vue?vue&type=script&lang=js"
import style0 from "./SeparatorExtended.vue?vue&type=style&index=0&id=1f856512&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f856512",
  null
  
)

export default component.exports